import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Popover from '@parkwhiz-js/react-popover';
import ClickOutside from 'react-click-outside';

import { Link } from 'react-router-dom';

import { ParkingPass } from 'models/parking-passes';

const propTypes = {
  parkingPass: PropTypes.instanceOf(ParkingPass).isRequired,
};

const trigger = (
  <span className="margin-top-20 text-color-white text-size-12 clickable">
    <span className="text-weight-medium">Name&nbsp;</span>
    <span className="text-weight-book text-size-10 padding-right-5">(must match photo ID)&nbsp;</span>
    <span className="iconified-font iconified-info-circle-fill" />
  </span>
);

class NameOnPass extends Component {
  constructor(props) {
    super(props);

    this.hideTooltip = this.hideTooltip.bind(this);
  }

  hideTooltip() {
    this.tooltip.setState({ isPopoverShown: false });
  }

  render() {
    const { parkingPass } = this.props;
    if (!parkingPass.showNameOnPass) return null;
    return (
      <div className="margin-top-20">
        <ClickOutside onClickOutside={this.hideTooltip} >
          <Popover ref={(c) => { this.tooltip = c; }} position="bottom" trigger={trigger}>
            <div className="text-size-12 text-color-dark-slate text-weight-book" style={{ width: 250 }}>
              <span className="float-right padding-left-xs-5 iconified-font iconified-x text-color-blue clickable text-size-12" onClick={this.hideTooltip} />
              To update, you’ll need to cancel this booking then re-book with your name updated.<br />
              If you have an account, update how your name appears in <Link className="text-weight-bold" to={{ pathname: '/account/settings/' }}>Account Settings</Link> before re-booking.
            </div>
          </Popover>
          <div className="text-weight-medium text-size-20 padding-top-xs-10">
            {parkingPass.firstname.toUpperCase()} {parkingPass.lastname.toUpperCase()}
          </div>
          <hr className="dashed-thin-line visible-lte-sm hidden-print" />
        </ClickOutside>
      </div>
    );
  }
}

NameOnPass.propTypes = propTypes;

export default NameOnPass;
